import React from "react";
import {
  Create,
  SimpleForm,
  TextInput,
  ReferenceInput,
  AutocompleteInput,
  FormDataConsumer,
  required,
  minLength,
  usePermissions,
  Identifier,
  RaRecord,
} from "react-admin";
import { parse } from "query-string";
import { useLocation } from "react-router";

import EmailInput from "../common/EmailInput";
import { validateEmailAddress } from "./validators";
import { SYSTEM_ADMINISTRATOR } from "../authProvider/roles";
import useCreateWithValidation from "../common/useCreateWithValidation";
import { PasswordInput } from "../common/PasswordInput";
import FormContainer from "../common/FormContainer";

const MailAccountCreate = () => {
  const { permissions } = usePermissions();
  const location = useLocation();
  // Read the post_id from the location which is injected by React Router and passed to our component by react-admin automatically
  const { customerId, domainId, returnTo } = parse(location.search);

  const fromDomain = (
    _resource?: string,
    _id?: Identifier,
    data?: Partial<RaRecord>,
    _state?: object
  ) => `Domain/${data?.domainId}/show/mail-accounts`;

  const save = useCreateWithValidation("MailAccount", {
    redirectTo: returnTo === "MailAccountFromDomains" ? fromDomain : "list",
  });

  return (
    <Create>
      <SimpleForm defaultValues={{ customerId, domainId }} onSubmit={save}>
        <FormContainer>
          <ReferenceInput
            source="customerId"
            reference="Customer"
            sort={{ field: "name", order: "ASC" }}
            filterToQuery={(searchText: any) => ({
              q: searchText,
            })}
          >
            <AutocompleteInput optionText="name" fullWidth validate={required()} />
          </ReferenceInput>
          <FormDataConsumer>
            {({ formData, ...rest }) => (
              <ReferenceInput
                source="domainId"
                reference="Domain"
                sort={{ field: "unicodeName", order: "ASC" }}
                filter={{ customerId: formData.customerId }}
                filterToQuery={(searchText: any) => ({
                  q: searchText,
                })}
                {...rest}
              >
                <AutocompleteInput optionText="unicodeName" fullWidth validate={required()} />
              </ReferenceInput>
            )}
          </FormDataConsumer>
          <EmailInput
            source="emailAddress"
            validate={validateEmailAddress}
            fullWidth
          />
          {permissions === SYSTEM_ADMINISTRATOR && (
            <TextInput
              source="username"
              helperText="Leer lassen, um Benutzernamen automatisch zu erzeugen."
              fullWidth
            />
          )}
          <PasswordInput
            source="password"
            validate={[required(), minLength(8)]}
            fullWidth
          />
        </FormContainer>
      </SimpleForm>
    </Create>
  );
};
export default MailAccountCreate;
